module.exports = __webpack_public_path__ + "img/9784bb8.png";